import Vue from 'vue';
import { CC_CONTAINER_TYPES } from '@/main/webapp/resources/src/vue/infrastructure/ioc/cc-container-types';
import { Component, Watch, Inject } from 'vue-property-decorator';
import CcServiceInterface from '@/main/webapp/resources/src/vue/service/cc-service-interface';
import CcProduct from '@/main/webapp/resources/src/vue/domain/product/cc-product';
import { CcProductattributeOption, CcProductAttribute } from '@/main/webapp/resources/src/vue/domain/product/cc-productattribute';
import Multiselect from 'vue-multiselect';
import CcCategory from '@/main/webapp/resources/src/vue/domain/category/cc-category';
import { Utils } from '@/main/webapp/resources/src/vue/infrastructure/utils/helpers';
import CcBannerArea from '@/main/webapp/resources/src/vue/domain/banner/cc-banner-area';
import CcProductStock from '@/main/webapp/resources/src/vue/domain/productstock/cc-productstock';
import CcBrand from '@/main/webapp/resources/src/vue/domain/brand/cc-brand';
import CcBanner from '@/main/webapp/resources/src/vue/domain/banner/cc-banner';
import CcUser from '@/main/webapp/resources/src/vue/domain/user/cc-user';
import CcProductTag from '@/main/webapp/resources/src/vue/domain/product/cc-product-tag';
import CcOrder from '@/main/webapp/resources/src/vue/domain/order/cc-order';
const UiPanelComponent = () => import(/* webpackChunkName: 'ui-panel' */ '@/main/webapp/resources/src/vue/components/ui-panel/ui-panel.vue');
const UiSetComponent = () => import(/* webpackChunkName: 'ui-set' */ '@/main/webapp/resources/src/vue/components/ui-set/ui-set.vue');
const UiTabbedPaneComponent = () => import(/* webpackChunkName: 'ui-tabbed-pane' */ '@/main/webapp/resources/src/vue/components/ui-tabbed-pane/ui-tabbed-pane.vue');
const UiTabbedPanelComponent = () => import(/* webpackChunkName: 'ui-tabbed-panel' */ '@/main/webapp/resources/src/vue/components/ui-tabbed-panel/ui-tabbed-panel.vue');
const CcCategoriesPanelComponent = () => import(/* webpackChunkName: 'cc-categories-panel' */ '@/main/webapp/resources/src/vue/components/cc-categories-panel/cc-categories-panel.vue');
const CcProductComponent = () => import(/* webpackChunkName: 'cc-product' */ '@/main/webapp/resources/src/vue/components/cc-product/cc-product.vue');
const CcBannerAreaComponent = () => import(/* webpackChunkName: 'cc-banner-area' */ '@/main/webapp/resources/src/vue/components/cc-banner-area/cc-banner-area.vue');
const UiModalComponent = () => import(/* webpackChunkName: 'ui-modal' */ '@/main/webapp/resources/src/vue/components/ui-modal/ui-modal.vue');

@Component({
	components: {
		CcCategoriesPanel: CcCategoriesPanelComponent,
		CcProduct: CcProductComponent,
		CcProductStock: Utils.getCustomComponent('cc-product-stock'),
		CcBannerArea: CcBannerAreaComponent,
		UiPanel: UiPanelComponent,
		UiTabbedPane: UiTabbedPaneComponent,
		UiTabbedPanel: UiTabbedPanelComponent,
		UiSet: UiSetComponent,
		Multiselect,
		UiModal: UiModalComponent
	},
	filters: {
		category: (categoryLabel: string) => {
			return categoryLabel || Vue.$translator.t('cc_components_cc_home_all_categories', {});
		},
		integer: (value: number) => {
			return new Intl.NumberFormat(navigator.language).format(value);
		}
	}
})
export default class CcPageHomeComponent extends Vue {
	@Inject(CC_CONTAINER_TYPES.CcServiceInterface)
	private service!: CcServiceInterface;

	private isBusy: boolean = false;
	private reload: boolean = true;
	private reset: boolean = true;
	private messagePageTitle: string = '';
	private messagePageHtml: string = '';
	static readonly UI_PANEL_FILTERS_ID: string = 'products-filter-panel';
	static readonly PRODUCTS_PER_PAGE: number = 24;
	static readonly MESSAGE_MODAL_ID: string = 'ui-modal.cc-page-home.message';
	static readonly SHOW_ON_STARTUP: string = 'cc-order-options-configuration.show_on_startup';
	private breadCrumbsPath: Array<CcCategory> = [];

	/** Generic getters and setter **/
	get messageModalId (): string {
		return CcPageHomeComponent.MESSAGE_MODAL_ID;
	}

	get uiPanelFiltersId (): string {
		return CcPageHomeComponent.UI_PANEL_FILTERS_ID;
	}

	get bannerAreaHomePrivate (): CcBannerArea {
		return this.$store.getters.bannerAreaHomePrivate;
	}

	get bannerAreaProducts (): CcBannerArea {
		return this.$store.getters.bannerAreaProducts;
	}

	get productAttributeOptions (): Array<any> {
		let result: Array<CcProductattributeOption> = [];

		CcProductAttribute.enumValues.forEach((attribute: any) => {
			result.push({
				label: this.$t(attribute.label, {}).toString(),
				code: attribute.name
			});
		});
		return result;
	}

	get customSortOptions (): Array<any> {
		return [
			{ code: null, label: this.$t('cc_components_cc_home_sort_option_sort_advices', {}) },
			{ code: 'PRICE', label: this.$t('cc_components_cc_home_sort_option_sort_price', {}) },
			{ code: 'DESCRIPTION', label: this.$t('cc_components_cc_home_sort_option_sort_description', {}) }
		];
	}

	get brands (): Array<CcBrand> {
		return this.$store.getters.brands;
	}

	set brands (brandList: Array<CcBrand>) {
		this.$store.dispatch('setBrands', brandList);
	}

	get pageData (): any {
		return this.$store.getters.pageData;
	}

	set pageData (pageData: any) {
		this.$store.dispatch('setPageData', pageData);
	}

	get pageDataTotalElement ():string {
		return new Intl.NumberFormat(navigator.language).format(this.pageData.totalElements);
	}

	get showAddPage (): boolean {
		const loadedItem: number = this.userLogged ? this.productStocks.length : this.products.length;
		return this.pageData.totalElements > loadedItem;
	}

	get selectedCategoryPath (): string {
		return this.$store.getters.searchCategoryPaths;
	}

	set selectedCategoryPath (categoryPaths: string) {
		this.$store.dispatch('setSearchCategoryPaths', categoryPaths);
	}

	get userLogged (): boolean {
		return this.$store.getters.user ? this.$store.getters.user.logged : false;
	}

	get user (): CcUser {
		return this.$store.getters.user;
	}

	get attributeList (): Array<any> {
		return this.$store.getters.searchAttribute;
	}

	set attributeList (attributeList: Array<any>) {
		this.$store.dispatch('setSearchAttribute', attributeList);
	}

	get isCategoryFilterActive () : boolean {
		return (this.selectedCategoryPath !== '');
	}

	get isBrandFilterActive (): boolean {
		return (this.brandList.length > 0);
	}

	get isAttributeFilterActive (): boolean {
		return (this.attributeList.length > 0);
	}

	get isFiltersActive (): boolean {
		return (this.isAttributeFilterActive || this.isBrandFilterActive || this.isCategoryFilterActive);
	}

	get activeFiltersCount (): number {
		let counter = 0;
		if (this.isCategoryFilterActive) {
			counter++;
		}
		if (this.isBrandFilterActive) {
			counter++;
		}
		if (this.isAttributeFilterActive) {
			counter++;
		}
		return counter;
	}

	get brandList (): Array<CcBrand> {
		return this.$store.getters.searchBrands;
	}

	set brandList (brandList: Array<CcBrand>) {
		this.$store.dispatch('setSearchBrands', brandList);
	}

	get elementsContainers (): number {
		let elemNumber: number = this.userLogged ? this.productStocks.length : this.products.length;
		return Math.ceil(elemNumber / CcPageHomeComponent.PRODUCTS_PER_PAGE);
	}

	get searchParams (): any {
		return this.$store.getters.searchParams;
	}

	set searchParams (searchParams: any) {
		this.$store.dispatch('setSearchParams', searchParams);
	}

	get searchDescriptionLike (): string {
		return this.$store.getters.searchDescriptionLike;
	}

	/** Products getters and setter **/
	get products (): Array<CcProduct> {
		return this.$store.getters.products;
	}

	set products (products: Array<CcProduct>) {
		this.$store.dispatch('setProducts', products);
	}

	/** ProductsStocks getters and setter **/

	get productStocks (): Array<CcProductStock> {
		return this.$store.getters.productStocks;
	}

	set productStocks (productStocks: Array<CcProductStock>) {
		this.$store.dispatch('setProductStocks', productStocks);
	}

	get searchCustomSort (): any {
		const sortCode:string = this.$store.getters.searchCustomSort;
		return this.customSortOptions.find((option:any) => option.code === sortCode);
	}

	set searchCustomSort (searchCustomSort: any) {
		this.$store.dispatch('setSearchCustomSort', searchCustomSort.code);
	}

	get categories (): Array<CcCategory> {
		return this.$store.getters.categories;
	}

	set categories (categories: Array<CcCategory>) {
		this.$store.dispatch('setCategories', categories);
	}

	get showBannerAreaHomePrivate (): boolean {
		const publishedBanner: boolean = this.bannerAreaHomePrivate ? this.bannerAreaHomePrivate.banners.filter((banner: CcBanner) => banner.published).length > 0 : false;
		return this.userLogged && publishedBanner;
	}

	get isFilterCategoriesEnabled (): boolean {
		return Utils.isFilterCategoriesEnabled();
	}

	get isFilterBrandsEnabled (): boolean {
		return Utils.isFilterBrandsEnabled() && this.brands.length > 0;
	}

	get isFilterTagsEnabled (): boolean {
		return Utils.isFilterTagsEnabled() && this.productTagsOptions.length > 0;
	}

	get isFilterTypesEnabled (): boolean {
		return Utils.isFilterTypesEnabled();
	}

	get productTagsOptions (): Array<any> {
		return this.$store.getters.productTags.map((productTag: CcProductTag) => {
			return { uniqueId: productTag.uniqueId, description: productTag.description };
		});
	}

	get tagsList (): Array<any> {
		return this.$store.getters.searchTags || [];
	}

	set tagsList (tagsList: Array<any>) {
		this.$store.dispatch('setSearchTags', tagsList);
	}

	get breadcrumbs (): Array<any> {
		return this.breadCrumbsPath.map((category: CcCategory) => {
			return { label: category.name, path: category.path };
		});
	}

	get orderOptionsModalId (): string {
		return Utils.ORDER_OPTIONS_MODAL_ID;
	}

	get currentOrder (): CcOrder {
		return this.$store.getters.order;
	}

	@Watch('isCategoryFilterActive')
	onChangeIsCategoryFilterActive (newValue: boolean) {
		this.$root.$emit('ui-tabbed-panel.set-tab-custom-class-list', `${this.uiPanelFiltersId}-tab-categories`, (newValue ? ['filtered'] : []));
	}

	@Watch('isBrandFilterActive')
	onChangeIsBrandFilterActive (newValue: boolean) {
		this.$root.$emit('ui-tabbed-panel.set-tab-custom-class-list', `${this.uiPanelFiltersId}-tab-brands`, (newValue ? ['filtered'] : []));
	}

	@Watch('isAttributeFilterActive')
	onChangeIsAttributeFilterActive (newValue: boolean) {
		this.$root.$emit('ui-tabbed-panel.set-tab-custom-class-list', `${this.uiPanelFiltersId}-tab-types`, (newValue ? ['filtered'] : []));
	}

	@Watch('searchParams.timestamp')
	onChangeSearchParams (newValue: number, oldValue: number) {
		if (!this.isBusy || (newValue - oldValue) > 1000) {
			if (this.userLogged) {
				this.loadProductStocks();
			}
		}
	}

	@Watch('pageData.number', { deep: true })
	onChangePageDataNumber (newValue: number, oldValue: number) {
		if (this.pageData.number > 0 && this.pageData.number !== oldValue) {
			if (this.userLogged) {
				this.loadProductStocks(true);
			}
		}
	}

	@Watch('$route')
	private reloadPage (to: any) {
		this.reload = to.params.reload !== 'false';
		this.reset = to.params.reset !== 'false';
		if (this.reset) {
			this.$store.dispatch('setAppKey', this.$store.getters.appKey + 1);
		} else if (this.reload) {
			this.initializeProductProcess();
		}
	}

	@Watch('selectedCategoryPath')
	private selectedCategoryPathChange (newValue: string) {
		if ((newValue || null) !== (<any> this.$route.query.categoryPaths || null)) {
			const query: any = Object.assign({}, this.$route.query, { categoryPaths: newValue || undefined });
			this.$router.replace({ query: Utils.clean(query) });
		}
		this.recursiveCategoryLoad();
	}

	@Watch('categories')
	private onChangeCategories () {
		this.recursiveCategoryLoad();
	}

	@Watch('brandList')
	onChangeSelectedBrand (newValue: Array<CcBrand>) {
		const query: any = Object.assign({}, this.$route.query, { brands: newValue.length ? newValue.map((brand: any) => brand.code) : undefined });
		this.$router.replace({ query: Utils.clean(query) });
	}

	@Watch('searchCustomSort')
	onChangeSearchCustomSort (newValue: any) {
		const sort: string = newValue ? newValue.code : null;
		const query: any = Object.assign({}, this.$route.query, { customSort: sort });
		this.$router.replace({ query: Utils.clean(query) });
	}

	@Watch('searchDescriptionLike')
	searchDescriptionLikeChange (newValue: any) {
		const query: any = Object.assign({}, this.$route.query, { descriptionLike: newValue });
		this.$router.replace({ query: Utils.clean(query) });
	}

	@Watch('currentOrder')
	ordersChange (newOrder: any, oldOrder: any) {
		if (newOrder?.shippingInformation?.code !== oldOrder?.shippingInformation?.code) {
			if (this.userLogged) {
				this.loadProductStocks();
			}
		}
	}

	beforeMount () {
		this.reload = this.$route.params.reload !== 'false';
		this.reset = this.$route.params.reset !== 'false';
		if (this.reset) {
			this.brands = [];
			this.categories = [];
		}
		if (this.brands.length === 0) {
			this.loadBrands();
		}
		if (this.categories.length === 0) {
			this.loadCustomCategory();
		} else {
			this.recursiveCategoryLoad();
		}
	}

	mounted () {
		this.initializeProductProcess();
	}

	private initializeProductProcess () {
		const urlSearchParams: any = {};
		if (this.userLogged) {
			if (this.reset) {
				this.resetFilters();
			} else if (this.reload || this.productStocks.length === 0) {
				urlSearchParams.categoryPaths = this.$route.query.categoryPaths || '';
				urlSearchParams.descriptionLike = this.$route.query.descriptionLike || '';
				urlSearchParams.attribute = this.$route.query.attribute || [];
				urlSearchParams.attribute = Array.isArray(urlSearchParams.attribute) ? urlSearchParams.attribute : [urlSearchParams.attribute];
				urlSearchParams.attribute = urlSearchParams.attribute.map((attributeCode: string) => { return { code: attributeCode }; });
				urlSearchParams.brands = this.$route.query.brands || [];
				urlSearchParams.brands = Array.isArray(urlSearchParams.brands) ? urlSearchParams.brands : [urlSearchParams.brands];
				urlSearchParams.brands = urlSearchParams.brands.map((brandCode: string) => { return { code: brandCode }; });
				urlSearchParams.customSort = this.$route.query.customSort || null;

				if (this.$route.query.reload) {
					delete this.$route.query.reload;
				}

				this.searchParams = urlSearchParams;
			}
		} else {
			this.$store.dispatch('setUrlPreLogin', this.$route.fullPath);
			this.$router.push({ name: 'login' });
		}
	}

	private openFiltersPanel () {
		this.$root.$emit('open-panel', CcPageHomeComponent.UI_PANEL_FILTERS_ID);
	}

	private closeFiltersPanel () {
		this.$root.$emit('close-panel', CcPageHomeComponent.UI_PANEL_FILTERS_ID);
	}

	private loadProductStocks (append: boolean = false) {
		this.isBusy = true;
		let params: any = {
			onSale: null,
			productAttributes: [],
			productBrandCodes: [],
			productTagIds: [],
			productCustomerDescriptionLike: this.searchDescriptionLike,
			productCustomCategoryPaths: this.selectedCategoryPath,
			customSort: this.searchCustomSort ? this.searchCustomSort.code : null,
			size: CcPageHomeComponent.PRODUCTS_PER_PAGE,
			page: append ? this.pageData.number : 0
		};
		if (this.brandList != null) {
			this.brandList.forEach((brand: CcBrand) => {
				params.productBrandCodes.push(brand.code);
			});
		}
		this.attributeList.forEach((attribute: any) => {
			params.productAttributes.push(attribute.code);
		});

		Utils.setWorking(true, <HTMLElement> this.$el.getElementsByClassName('ui-container-grid')[0]);
		this.service.getProductStocks(params)
			.then((response: any) => {
				if (append) {
					this.productStocks.push(...response.productStocks);
				} else {
					this.productStocks = response.productStocks;
				}

				if (response.page) {
					this.pageData = response.page;
				}
				this.isBusy = false;
				Utils.setWorking(false, <HTMLElement> this.$el.getElementsByClassName('ui-container-grid')[0]);
			})
			.catch((error: Error) => {
				Utils.setWorking(false, <HTMLElement> this.$el.getElementsByClassName('ui-container-grid')[0]);
				Utils.defaultApiErrorHandler(error);
			});
	}

	private addPage () {
		const loadedItem: number = this.userLogged ? this.productStocks.length : this.products.length;
		if (this.pageData.totalElements > loadedItem) {
			const pageInfo: any = this.pageData;
			pageInfo.number = pageInfo.number + 1;
			this.pageData = pageInfo;
		}
	}

	private removeSelectedAttribute (removedAttribute: CcProductattributeOption) {
		this.attributeList.forEach((attribute: CcProductattributeOption, index: number) => {
			if (attribute.code === removedAttribute.code) {
				this.attributeList.splice(index, 1);
			}
		});
	}

	private removeSelectedBrands () : void {
		this.brandList = [];
	}

	private removeSelectedAttributes () : void {
		this.attributeList = [];
	}

	private resetFilters () : void {
		this.brandList = [];
		this.attributeList = [];
		this.resetSearchParameters();
		this.$root.$emit('reset-ui-set-selected-options', 'ui-set-brands');
		this.$root.$emit('reset-ui-set-selected-options', 'ui-set-attributes');
		this.closeFiltersPanel();
	}

	private resetSearchParameters (): void {
		this.$store.dispatch('setSearchParams', {
			categoryPaths: '',
			descriptionLike: '',
			customSort: null,
			attribute: [],
			brands: []
		});
	}

	private loadBrands (): void {
		this.service.getBrands()
			.then((brands: Array<CcBrand>) => {
				this.brands = brands;
			})
			.catch((error: Error) => {
				Utils.defaultApiErrorHandler(error);
			});
	}

	private loadCustomCategory (category: CcCategory = null) {
		if (!category?.leaf) {
			this.service.getCustomCategory({ path: category?.path })
				.then((categoryList: Array<CcCategory>) => {
					if (category) {
						category.children = categoryList;
						this.categories = [...this.categories];
					} else {
						this.categories = categoryList;
					}
				})
				.catch((error: Error) => {
					Utils.defaultApiErrorHandler(error);
				});
		}
	}

	private updateSelectedBrands (selectedBrands: Array<CcBrand>): void {
		this.brandList = selectedBrands;
	}

	private updateSelectedAttribute (selectedCategories: Array<CcCategory>): void {
		this.attributeList = selectedCategories;
	}

	private productStocksIn (containerKey: number): Array<CcProductStock> {
		const start: number	= CcPageHomeComponent.PRODUCTS_PER_PAGE * containerKey;
		const end: number	= CcPageHomeComponent.PRODUCTS_PER_PAGE * (containerKey + 1);
		return this.productStocks.slice(start, end);
	}

	private messageModalCreated () {
		this.showMessage();
	}

	private showMessage () {
		this.service.getPage('message')
			.then((pageData: any) => {
				if (pageData.published) {
					const showDate: string = Utils.localStorageGetItem(CcPageHomeComponent.MESSAGE_MODAL_ID);
					const checkDate: string = (pageData.lastModifiedDate) ? pageData.lastModifiedDate : pageData.creationDate;
					if (showDate === null || showDate < checkDate) {
						this.messagePageHtml = pageData.html;
						this.messagePageTitle = pageData.title;
						this.$root.$emit('ui-modal.open', CcPageHomeComponent.MESSAGE_MODAL_ID);
						Utils.localStorageSetItem(CcPageHomeComponent.MESSAGE_MODAL_ID, checkDate);
					}
				}
			})
			.catch(() => {});
	}

	private recursiveCategoryLoad () {
		const selectedPathChunks: Array<string> = this.selectedCategoryPath.split('-');
		let categoryList: Array<CcCategory> = this.categories;
		this.breadCrumbsPath = [];

		if (this.selectedCategoryPath !== '') {
			selectedPathChunks.every((pathChunk: string) => {
				const category: CcCategory = this.findCategory(pathChunk, categoryList);
				if (category) {
					categoryList = category.children;
					this.breadCrumbsPath.push(category);
					if (category.children.length === 0 && !category.leaf) {
						// Carico i figli da mostrare nel pannello
						this.loadCustomCategory(category);
						return false;
					}
				}
				return !!category;
			});
		}
	}

	private findCategory (searchCode: string, categoryList: Array<CcCategory>): CcCategory {
		return categoryList.find((category: CcCategory) => category.code === searchCode);
	}
}
